import type { ReactNode } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import SettingsIcon from '@mui/icons-material/Settings';
import type { UserRole } from '@/lib/types/domain';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  exact?: boolean;
}

const superAdminNav: NavItem[] = [
  { to: '/app/super/overview', label: 'Overview', icon: <DashboardIcon /> },
  { to: '/app/super/health-insights', label: 'Health Insights', icon: <MonitorHeartIcon /> },
  { to: '/app/super/organizations', label: 'Organizations', icon: <BusinessIcon /> },
  { to: '/app/super/licenses', label: 'Licenses', icon: <AssessmentIcon /> },
  { to: '/app/super/audit', label: 'Audit log', icon: <HistoryIcon /> },
];

const orgAdminNav: NavItem[] = [
  { to: '/app/org/overview', label: 'Overview', icon: <DashboardIcon /> },
  { to: '/app/org/health-insights', label: 'Health Insights', icon: <MonitorHeartIcon /> },
  { to: '/app/org/employees', label: 'Employees', icon: <PeopleIcon /> },
  { to: '/app/org/employees/import', label: 'Bulk import', icon: <UploadFileIcon /> },
  { to: '/app/org/invitations', label: 'Invitations', icon: <ForwardToInboxIcon /> },
  { to: '/app/org/settings', label: 'Settings', icon: <SettingsIcon /> },
];

export function navForRole(role: UserRole): NavItem[] {
  return role === 'SUPER_ADMIN' ? superAdminNav : orgAdminNav;
}
